(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-call-for-price"]) return;
  try {
    
/*
var loadProductRecommendationsIntoSection = function() {
	// Look for an element with class 'product-recommendations'
	var productRecommendationsSection = document.querySelector(".product-recommendations");
	if (productRecommendationsSection === null) { return; }

	// Read product id from data attribute
	var productId = productRecommendationsSection.dataset.productId;

	// Read limit from data attribute
	var limit = productRecommendationsSection.dataset.limit;

	console.log("Here");

	// Build request URL
	var requestUrl = "/recommendations/products.json?section_id=product-recommendations&limit=" + limit + "&product_id=" + productId;

	// Create request and submit it using Ajax
	var request = new XMLHttpRequest();
	request.open("GET", requestUrl);
	request.onload = function() {
		if (request.status >= 200 && request.status < 300) {
        	console.log(request.response);
        }
     }
     request.send();
};

// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();
*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-contact-us-to-order"]) return;
  try {
    
/*
var loadProductRecommendationsIntoSection = function() {
	// Look for an element with class 'product-recommendations'
	var productRecommendationsSection = document.querySelector(".product-recommendations");
	if (productRecommendationsSection === null) { return; }

	// Read product id from data attribute
	var productId = productRecommendationsSection.dataset.productId;

	// Read limit from data attribute
	var limit = productRecommendationsSection.dataset.limit;

	console.log("Here");

	// Build request URL
	var requestUrl = "/recommendations/products.json?section_id=product-recommendations&limit=" + limit + "&product_id=" + productId;

	// Create request and submit it using Ajax
	var request = new XMLHttpRequest();
	request.open("GET", requestUrl);
	request.onload = function() {
		if (request.status >= 200 && request.status < 300) {
        	console.log(request.response);
        }
     }
     request.send();
};

// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();
*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
/*
var loadProductRecommendationsIntoSection = function() {
	// Look for an element with class 'product-recommendations'
	var productRecommendationsSection = document.querySelector(".product-recommendations");
	if (productRecommendationsSection === null) { return; }

	// Read product id from data attribute
	var productId = productRecommendationsSection.dataset.productId;

	// Read limit from data attribute
	var limit = productRecommendationsSection.dataset.limit;

	console.log("Here");

	// Build request URL
	var requestUrl = "/recommendations/products.json?section_id=product-recommendations&limit=" + limit + "&product_id=" + productId;

	// Create request and submit it using Ajax
	var request = new XMLHttpRequest();
	request.open("GET", requestUrl);
	request.onload = function() {
		if (request.status >= 200 && request.status < 300) {
        	console.log(request.response);
        }
     }
     request.send();
};

// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();
*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by"] && !Shopify.designMode) return;
  try {
    

$(".shop-by__buttons > button").click(function(e) {
	e.preventDefault();
	if (!$(this).hasClass("active")) {
		var parent = $(this).parents(".shop-by");
		
		parent.find(".shop-by__buttons > button.active").removeClass("active");
		parent.find(".shop-by__row.active").removeClass("active");
		
		$(this).addClass("active");
		$("#" + $(this).attr("data-id")).addClass("active");
	}
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stove-search"] && !Shopify.designMode) return;
  try {
    

$('.stove-search > form').submit(function(e) {
	e.preventDefault();
	var url = '/collections/' + $(this).find("[name=collection]").val();
	url += '/range_' + $(this).find("[name=range]").val();
	url += '+heat-output_' + $(this).find("[name=heat-output]").val();
	window.location.href = url;
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-pages"] && !Shopify.designMode) return;
  try {
    

$(".tabs-pages__buttons > button").click(function(e) {
	e.preventDefault();
	if (!$(this).hasClass("active")) {
		$(".tabs-pages__buttons > button.active").removeClass("active");
		$(".tabs-pages__links.active").removeClass("active");
		
		$(this).addClass("active");
		$("#" + $(this).attr("data-id")).addClass("active");
	}
});


  } catch(e) { console.error(e); }
})();
})();
